import { FactoryPaperCell, FactoryGridCell } from '../../../ui/Views/Announcements/Cells';
import { VIEW_MODE } from '../../../consts';

/**
 * Возвращает фабрику для построения ячеек в табличном виде
 * @param viewMode
 * @param user
 * @param domain
 * @returns {*}
 */
export function getCellSearchFactory (viewMode, user, domain) {
  if (viewMode === VIEW_MODE.grid) {
    return new FactoryGridCell(user, domain);
  }

  if (viewMode === VIEW_MODE.paper) {
    return new FactoryPaperCell(user, domain);
  }

  return new FactoryGridCell(user, domain);
}



// WEBPACK FOOTER //
// ./src/classes/builder/search/cellFactoryBuilder.js